// extracted by mini-css-extract-plugin
export default {"sup_first":"Support_sup_first__0hELk"};